import React from 'react';
import { translations } from '../Text/translations';
import maxActivationImage from '../../assets/max/Max-Activation.png';

const StbMaxError = ({ currentLang }) => {
    return (
        <>
            <div className='message'>
                <h2>{translations[currentLang].stbMaxErrorTitle}</h2>
                <p>{translations[currentLang].stbMaxErrorContent}</p>
            </div>

            <div className='preview-img'>
                <img src={maxActivationImage} alt='' />
            </div>
        </>
    );
};

export default StbMaxError;
